import React, { useState } from "react";
import {
  AppContainer,
  CardTitle,
  CompactDocumentCard,
  CompactInfoCard,
  CompactInfoGrid,
  CompactInfoRow,
  CompactLabel,
  CompactValue,
  DocumentLink,
  DocumentPreview,
  DocumentsContainer,
  MainContent,
  ProfileAvatar,
  ProfileContainer,
  ProfileImageContainer,
  ProfileImageSection,
  StatusBadge,
} from "./style";
import ImagePopup from "../../components/ImagePopup"; 

const DriverProfile = ({ driver }) => {
  const { user, vehicle, license_img, id_card_img, availability, status } =
    driver;
  
  const [imagePopup, setImagePopup] = useState({
    isOpen: false,
    imageUrl: "",
    title: ""
  });

  const defaultProfileImage = `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(
    user.name
  )}&size=200&backgroundType=gradientLinear&fontWeight=500`;

  const handleImageClick = (img, title) => {
    setImagePopup({
      isOpen: true,
      imageUrl: img,
      title: title
    });
  };

  return (
    <AppContainer>
      {/* Image Popup Component */}
      <ImagePopup
        isOpen={imagePopup.isOpen}
        imageUrl={imagePopup.imageUrl}
        title={imagePopup.title}
        onClose={() => setImagePopup({ isOpen: false, imageUrl: "", title: "" })}
      />

      <ProfileContainer>
        <ProfileImageSection>
          <ProfileImageContainer>
            <ProfileAvatar
              src={user.profile_img || defaultProfileImage}
              alt={user.name}
              onError={(e) => {
                e.target.src = defaultProfileImage;
              }}
            />
          </ProfileImageContainer>

          <StatusBadge status={availability || status}>
            {availability || status}
          </StatusBadge>
        </ProfileImageSection>

        <MainContent>
          <CompactInfoGrid>
            <CompactInfoCard>
              <CardTitle>المعلومات الشخصية</CardTitle>
              <CompactInfoRow>
                <CompactLabel>الاسم الكامل : </CompactLabel>
                <CompactValue>{user.name}</CompactValue>
              </CompactInfoRow>
              <CompactInfoRow>
                <CompactLabel> البريد الإلكتروني : </CompactLabel>
                <CompactValue>{user.email}</CompactValue>
              </CompactInfoRow>
              <CompactInfoRow>
                <CompactLabel>رقم الهاتف : </CompactLabel>
                <CompactValue>{user.phone_number}</CompactValue>
              </CompactInfoRow>
              <CompactInfoRow>
                <CompactLabel>تاريخ التسجيل : </CompactLabel>
                <CompactValue>
                  {user.registration_date || "غير محدد"}
                </CompactValue>
              </CompactInfoRow>
            </CompactInfoCard>

            {vehicle && (
              <CompactInfoCard>
                <CardTitle>معلومات المركبة</CardTitle>
                <CompactInfoRow>
                  <CompactLabel>نوع المركبة:</CompactLabel>
                  <CompactValue>{vehicle.vehicle_type}</CompactValue>
                </CompactInfoRow>
                <CompactInfoRow>
                  <CompactLabel>العلامة التجارية:</CompactLabel>
                  <CompactValue>{vehicle.brand}</CompactValue>
                </CompactInfoRow>
                <CompactInfoRow>
                  <CompactLabel>رقم اللوحة:</CompactLabel>
                  <CompactValue>{vehicle.license_plate}</CompactValue>
                </CompactInfoRow>
                <CompactInfoRow>
                  <CompactLabel>سنة الصنع:</CompactLabel>
                  <CompactValue>{vehicle.manufacture_year}</CompactValue>
                </CompactInfoRow>
              </CompactInfoCard>
            )}
          </CompactInfoGrid>

          <CompactInfoCard style={{ marginTop: "1.5rem" }}>
            <CardTitle>المستندات المرفقة</CardTitle>
            <DocumentsContainer>
              <CompactDocumentCard>
                <CompactLabel>رخصة القيادة:</CompactLabel>
                {license_img ? (
                  <>
                    <DocumentPreview 
                      src={license_img} 
                      alt="رخصة القيادة" 
                      onClick={() => handleImageClick(license_img, "رخصة القيادة")}
                      style={{ cursor: "pointer" }}
                    />
                    <DocumentLink 
                      href="#" 
                      onClick={(e) => {
                        e.preventDefault();
                        handleImageClick(license_img, "رخصة القيادة");
                      }}
                    >
                      عرض المستند
                    </DocumentLink>
                  </>
                ) : (
                  <CompactValue>غير متوفر</CompactValue>
                )}
              </CompactDocumentCard>

              <CompactDocumentCard>
                <CompactLabel>بطاقة الهوية:</CompactLabel>
                {id_card_img ? (
                  <>
                    <DocumentPreview 
                      src={id_card_img} 
                      alt="بطاقة الهوية" 
                      onClick={() => handleImageClick(id_card_img, "بطاقة الهوية")}
                      style={{ cursor: "pointer" }}
                    />
                    <DocumentLink 
                      href="#" 
                      onClick={(e) => {
                        e.preventDefault();
                        handleImageClick(id_card_img, "بطاقة الهوية");
                      }}
                    >
                      عرض المستند
                    </DocumentLink>
                  </>
                ) : (
                  <CompactValue>غير متوفر</CompactValue>
                )}
              </CompactDocumentCard>
            </DocumentsContainer>
          </CompactInfoCard>
        </MainContent>
      </ProfileContainer>
    </AppContainer>
  );
};

export default DriverProfile;